import { EAvailableFaceLanguages } from "./language";

// Для расширения списка жанров, достаточно добавить slug в этом месте
const GENRES_DASHBOARD_SLUGS = new Set([
  "knigi-fentezi-5018",
  "samorazvitiye-lichnostnyy-rost-5253",
  "knigi-lubovnye-romany-5005",
  "komiksy-i-manga-274060",
  "knigi-detektivy-5022",
  "knigi-sovremennaya-proza-5015",
  "detskie-knigi-5007",
  "knigi-ezoterika-5011",
  "knigi-uzhasy-mistika-5017",
  "young-adult-174918",
  "erotika-seks-5029",
  "istoriya-201599",
  "biografii-memuary-5169",
  "nauchno-populyarnaya-literatura-5031",
  "kompyuternaya-literatura-5024",
  "knigi-fantastika-5004",
  //az, uz
  "ezoterika-5011",
  "biznes-5003",
  //az, uz
  "biznes-kitablari-5003",
]);

export const EXCLUDE_STATIC_GENRES_LINKS = ["/podcasts/"];

export const GENRE_QUERY_VIEW = "view=showroom";

const GENRES_DASHBOARD_LINKS = Array.from(GENRES_DASHBOARD_SLUGS).reduce(
  (prev: { [key: string]: string }, slug) => {
    prev[`/genre/${slug}/`] = `/genre/${slug}/?${GENRE_QUERY_VIEW}`;
    return prev;
  },
  {}
);

export const isDashboardPage = (link: string): boolean =>
  !!GENRES_DASHBOARD_LINKS[link];

// Функция позволяет получить новую ссылку, если жанр входит в АБ тест
export const transformGenreLink = (link: string): string => {
  return GENRES_DASHBOARD_LINKS[link] ?? link;
};

// Функция исправляет ссылку для переданного жанра, если его урл присутствует в GENRES_DASHBOARD_LINKS
export const transformGenreItemData = <
  T extends { id: number; url?: string | null; subgenres?: T[] },
>(
  genreItem: T,
  isSEOGenreTree?: boolean,
  lang?: EAvailableFaceLanguages
) => {
  // замена урлов для статичного дерева жанров
  if (
    isSEOGenreTree &&
    lang === EAvailableFaceLanguages.ru &&
    genreItem.id &&
    genreItem.url &&
    !EXCLUDE_STATIC_GENRES_LINKS.includes(genreItem.url)
  ) {
    const slugList = genreItem.url
      .split("/")
      .filter((item: string) => item?.length > 0);

    const lastItem = slugList.at(-1);

    return {
      ...genreItem,
      url: `/genre/${lastItem}-${genreItem.id}/`,
    };
  }

  if (genreItem.url && GENRES_DASHBOARD_LINKS[genreItem.url]) {
    return {
      ...genreItem,
      url: transformGenreLink(genreItem.url),
    };
  }
  return genreItem;
};

// Функция трансформации ссылок на жанры для дерева жанров (рутовый и поджанры 2-ого уровня)
export const transformGenresData = <
  T extends { id: number; url?: string | null; subgenres?: T[] },
>(
  data: T[],
  isSEOGenreTree?: boolean,
  lang?: EAvailableFaceLanguages
): T[] => {
  return data.map((genre: T) => {
    return {
      ...transformGenreItemData(genre, isSEOGenreTree, lang),
      subgenres:
        genre.subgenres?.map((subgenre: T) =>
          transformGenreItemData(subgenre, isSEOGenreTree, lang)
        ) ?? [],
    } as T;
  });
};
